import React, { Dispatch, SetStateAction } from 'react';
import { DeliveryProps } from '../../constants/types';
import TextWinds from '../common/TextWinds';
import { ChevronRightIcon } from '@heroicons/react/20/solid';
import { Chip } from '@material-tailwind/react';
import {
  deleteDeliveryInfo,
  getDeliveryInfoList,
  setEditDeliveryInfo,
} from '../../store/features/orderInfoSlice';
import { useAppDispatch } from '../../store/hook';
import Buttons from '../button/Buttons';
import { phoneFormat } from '../../api/utils/format/numbers';

interface DeliveryInfoCardProps {
  deliveryInfo: DeliveryProps;
  onClick?: () => void;
  editable?: boolean;
  setState?: Dispatch<SetStateAction<'form' | 'none' | 'list'>>;
}
const DeliveryInfoCard = ({
  deliveryInfo,
  onClick,
  editable,
  setState,
}: DeliveryInfoCardProps) => {
  const dispatch = useAppDispatch();
  const editClick = (
    e: React.MouseEvent<HTMLElement, MouseEvent>,
    deliveryInfo: DeliveryProps,
  ) => {
    setState && setState('form');
    dispatch(setEditDeliveryInfo(deliveryInfo));
    e.stopPropagation();
  };

  const deleteClick = (deliveryInfo: DeliveryProps) => {
    if (deliveryInfo.isDefault) {
      window.alert('기본 배송지는 삭제할 수 없습니다.');
      return;
    }

    const result: boolean = window.confirm(
      `[${deliveryInfo.name}] 배송지를 삭제하시겠습니까?`,
    );
    if (result) {
      dispatch(
        deleteDeliveryInfo({ url: '', params: { id: deliveryInfo.id } }),
      ).then(() => {
        dispatch(getDeliveryInfoList({ url: '', params: {} }));
      });
      // 삭제 호출 후 목록 새로 조회
    }
  };

  if (!deliveryInfo) {
    return (
      <Buttons
        className="mt-[16px] flex w-full items-center rounded-md border-[1px] border-gray5 bg-white px-[14px] py-[12px] hover:bg-gray1"
        onClick={onClick}
        type={'text'}
        color={'gray7'}
      >
        <div className="flex w-full flex-col gap-[6px] text-left">
          <div className="flex justify-between">
            <div className="flex items-center">
              <TextWinds type="caption1">배송지를 추가해주세요.</TextWinds>
            </div>
            <div>
              <ChevronRightIcon
                strokeWidth={2.5}
                className="h-10 w-10"
                fill="gray"
              />
            </div>
          </div>
        </div>
      </Buttons>
    );
  }

  return (
    <Buttons
      className="mt-[16px] flex w-full items-center rounded-md border-[1px] border-gray5 bg-white px-[14px] py-[12px] hover:bg-gray1"
      onClick={onClick}
      type={'text'}
      color={'gray7'}
    >
      <div className="flex w-full flex-col gap-[6px] text-left">
        <div className="flex justify-between">
          <div className="shrink-1 flex flex-col justify-center">
            <div>
              {deliveryInfo.isDefault && (
                <Chip
                  variant="filled"
                  className="mb-2 inline-flex h-[20px] flex-shrink-0 bg-purple1 px-[4px] text-purple5"
                  value="기본 배송지"
                />
              )}
            </div>
            <TextWinds type="content_rel">{deliveryInfo.name}</TextWinds>
            <TextWinds type="caption1" color="gray7">
              {deliveryInfo.address}
            </TextWinds>
            <TextWinds type="caption1" color="gray7">
              {deliveryInfo.detailAddress}
            </TextWinds>
            <TextWinds type="caption1">
              {phoneFormat(deliveryInfo.phone)}
            </TextWinds>
          </div>

          <div className="flex shrink-0 items-center justify-center">
            {editable ? (
              <div className="flex flex-col gap-4">
                <div
                  onClick={(e) => {
                    editClick(e, deliveryInfo);
                  }}
                >
                  <TextWinds type="caption1" className="font-bold">
                    수정
                  </TextWinds>
                </div>
                {/* {!deliveryInfo.isDefault && (
                  <div
                    onClick={(e) => {
                      e.stopPropagation();
                      deleteClick(deliveryInfo);
                    }}
                  >
                    <TextWinds type="caption1" className="text-red-500">
                      삭제하기
                    </TextWinds>
                  </div>
                )} */}
                <div onClick={onClick}>
                  <TextWinds type="caption1" className="font-bold text-purple5">
                    선택
                  </TextWinds>
                </div>
              </div>
            ) : (
              <ChevronRightIcon
                strokeWidth={2.5}
                className="h-10 w-10"
                fill="gray"
              />
            )}
          </div>
        </div>
      </div>
    </Buttons>
  );
};

export default DeliveryInfoCard;
